/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfbreq23Inputs */

const en_crosspostinghelpfbreq23 = /** @type {(inputs: Crosspostinghelpfbreq23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Facebook profile must have full control (unrestricted access) of that Page.`)
};

const de_crosspostinghelpfbreq23 = /** @type {(inputs: Crosspostinghelpfbreq23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Facebook-Profil muss uneingeschränkten Zugriff (volle Kontrolle) auf dieser Seite haben.`)
};

/**
* | output |
* | --- |
* | "Your Facebook profile must have full control (unrestricted access) of that Page." |
*
* @param {Crosspostinghelpfbreq23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfbreq23 = /** @type {((inputs?: Crosspostinghelpfbreq23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfbreq23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfbreq23(inputs)
	return de_crosspostinghelpfbreq23(inputs)
});
export { crosspostinghelpfbreq23 as "crosspostingHelpFbReq2" }